import { useAuthentication } from "authentication/AuthenticationContext";
import { useNavigate } from "react-router-dom";
import BaseButton from "base/BaseButton";
import React from "react";

const AccountMenu = ({ oncloseMenu }) => {
  const { user, isAdmin, signOut } = useAuthentication();
  const navigate = useNavigate();

  const handleAdminClick = () => {
    navigate("/admin");
    oncloseMenu();
  };

  const handleLoginClick = () => {
    navigate("/login");
    oncloseMenu();
  };

  const handleSignupClick = () => {
    navigate("/signup");
    oncloseMenu();
  };

  const handleSignOut = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error("Error signing out:", error);
    }
    oncloseMenu();
  };

  return (
    <div className="Space-E p-10 Row w-90">
      {user ? (
        <>
          {isAdmin && (
            <BaseButton
              buttonText="Admin"
              handleClick={handleAdminClick}
              widthClass="w-48"
            />
          )}
          <BaseButton
            buttonText="Logout"
            handleClick={handleSignOut}
            widthClass={isAdmin ? "w-48" : "w-90"}
          />
        </>
      ) : (
        <>
          <BaseButton
            buttonText="Login"
            widthClass="w-100"
            handleClick={handleLoginClick}
          />
          <BaseButton
            buttonText="Sign Up"
            widthClass="w-100"
            handleClick={handleSignupClick}
          />
        </>
      )}
    </div>
  );
};

export default AccountMenu;
